<ion-content [fullscreen]="true" class="ion-padding sheet">
	<div class="content-wrapper">
		<ion-icon class="alert-icon" name="hourglass-outline"></ion-icon>

		<h2 class="title">{{ 'discountingBlocked.title' | translate }}</h2>

		<p class="message">{{ 'discountingBlocked.message' | translate }}</p>

		<ion-spinner name="crescent"></ion-spinner>
	</div>
</ion-content>
